// Авторизація для веб-версії (поза Telegram Mini App).
// Зберігаємо JWT у localStorage. У Mini App цей механізм неактивний — там
// initData приходить з SDK і використовується напряму.

import { getInitData } from './telegram';

const TOKEN_KEY = 'testypdr_jwt';

export function getToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

// Чи юзер автентифікований? Для Mini App — так (бо є initData), для веб — лише якщо є JWT.
export function isAuthenticated(): boolean {
  return Boolean(getInitData()) || Boolean(getToken());
}

// Чи це Mini App (Telegram WebView)? Визначаємо за наявністю initData.
export function isMiniApp(): boolean {
  return Boolean(getInitData());
}
